function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchwarzmueller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "graphics-document",
    title: "logo (1)",
    id: "SCHW_Master",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3401.57 425.2",
    preserveAspectRatio: "xMinYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "SCHW_Logo-pos") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1361.35,254.58l9.87-42.85h-3.44c-8.53,0-15.21-2.48-18.8-7a15.82,15.82,0,0,1-2.84-5.82l-15-54.5c19.52-2.19,50-14.29,58.15-49.87l4.51-19.27c7.65-37,4.86-75.27-73.95-75.27H1235l-58.73,254.59h50.88l25.32-109.79h28l25.07,91.57,1.47,5.41a15.64,15.64,0,0,0,2.83,5.8c3.59,4.52,10.28,7,18.81,7h32.75Zm-17.87-187-1.18,5.31-2.58,11.74-1.57,5.55c-2.77,10.88-10.9,13.7-24.86,13.78h-51.42l14.61-63.32h45.59c8.54,0,15.22,2.49,18.81,7S1345.4,59.23,1343.48,67.56Z",
    transform: "translate(0 0)",
    style: {
      fill: "#1a171b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2861.73,254.58l9.87-42.85h-3.43c-8.54,0-15.22-2.48-18.81-7a16.16,16.16,0,0,1-2.85-5.82l-14.94-54.5c19.51-2.19,50-14.29,58.16-49.87l4.49-19.27c7.65-37,4.85-75.27-74-75.27h-84.9l-58.74,254.59h50.87l25.34-109.79h28l25.06,91.57,1.46,5.41a16,16,0,0,0,2.83,5.8c3.61,4.52,10.27,7,18.83,7h32.74Zm-17.87-187-1.19,5.31-2.58,11.74-1.56,5.55c-2.77,10.88-10.9,13.7-24.87,13.78h-51.42l14.62-63.32h45.58c8.55,0,15.23,2.49,18.82,7S2845.78,59.23,2843.86,67.56Z",
    transform: "translate(0 0)",
    style: {
      fill: "#1a171b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2241.13 0 2190.26 0 2131.53 254.59 2182.41 254.59 2182.41 254.59 2272.75 254.59 2282.14 213.86 2191.79 213.86 2241.13 0",
    style: {
      fill: "#1a171b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "573.67 93.97 488.34 93.97 510.01 0 459.14 0 400.41 254.59 451.29 254.59 478.94 134.71 564.27 134.71 536.62 254.59 587.49 254.59 646.22 0 595.34 0 573.67 93.97",
    style: {
      fill: "#1a171b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.13,0h-50.87l-141,254.58h50.88l34.33-62h81.23l2.3,62h50.88L1137.41,0ZM1035,151.85l53.55-96.7,3.6,96.7Z",
    transform: "translate(0 0)",
    style: {
      fill: "#1a171b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "948.81 0 864.86 185.91 864.86 0 813.99 0 813.99 0 813.6 0 726.62 188.19 726.62 0 675.76 0 675.76 254.59 695.95 254.59 695.95 254.59 738.74 254.59 813.99 91.78 813.99 254.59 833.85 254.59 833.85 254.59 883.82 254.59 998.79 0 948.81 0",
    style: {
      fill: "#1a171b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1831.01 0 1813.27 0 1758.03 154.97 1758.03 0 1707.18 0 1707.18 0 1684.94 0 1594.21 254.59 1642.4 254.59 1707.18 72.85 1707.18 254.59 1722.54 254.59 1722.54 254.59 1765.34 254.59 1831.01 70.33 1831.01 254.59 1881.88 254.59 1881.88 0 1831.01 0 1831.01 0",
    style: {
      fill: "#1a171b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2411.3 0 2360.42 0 2301.7 254.59 2352.57 254.59 2352.57 254.59 2442.91 254.59 2452.3 213.86 2361.97 213.86 2411.3 0",
    style: {
      fill: "#1a171b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2675.71 40.73 2685.1 0 2585.52 0 2538.23 0 2534.64 0 2475.93 254.59 2526.79 254.59 2526.79 254.59 2631.19 254.59 2640.59 213.86 2536.19 213.86 2552.15 144.68 2644.48 144.68 2653.88 103.94 2561.54 103.94 2576.13 40.73 2675.71 40.73",
    style: {
      fill: "#1a171b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.18,110.68l5.72-24.8c1.94-8.38,8.16-17.41,16.64-24.17s18.69-10.79,27.28-10.79h71.84L411.41,0H327.82c-42,0-84,33.49-93.49,74.42l-5.72,24.81-13,56.14c-12.59,54.57,22.9,99.21,78.86,99.21h75.63l11.74-50.9H294.52c-11.23,0-20.23-3.53-25.32-9.93s-6.5-16-4-26.93Z",
    transform: "translate(0 0)",
    style: {
      fill: "#1a171b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.26,50.27,46.7,86.33c-4.13,16.67,2.19,44.53,36.38,56.19l31.52,11.24c21.17,7.21,16.24,23.74,16.24,23.74L127.56,193c-2.19,9.48-12.69,10.59-15.45,10.68H11.74L0,254.58H112c18.37,0,55.51-10.4,64.68-50.26l7.57-36c4.13-16.69-2.19-44.55-36.38-56.2l-33.53-11.95c-18.43-5.67-14.3-22.69-14.3-22.69l3.37-16c2.18-9.47,12.68-10.56,15.45-10.66h74L204.63,0H118.94C100.57,0,63.44,10.4,54.26,50.27Z",
    transform: "translate(0 0)",
    style: {
      fill: "#1a171b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1613.65 28.79 1620.29 0 1592.05 0 1573.43 0 1459.55 0 1450.15 40.73 1541.38 40.73 1400.51 219.8 1392.36 255.12 1431.84 255.12 1435.58 255.12 1564.35 255.12 1573.74 214.38 1467.63 214.38 1613.65 28.79",
    style: {
      fill: "#1a171b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2014.28 0 1963.39 0 1951.65 50.92 2002.51 50.92 2014.28 0",
    style: {
      fill: "#1a171b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "2091.18 0 2079.45 50.92 2130.31 50.92 2142.05 0 2091.18 0",
    style: {
      fill: "#1a171b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2048.48,183.6c-2.2,9.57-15.4,20.08-25.2,20.08h-27.42c-8.54,0-15.22-2.5-18.8-7s-4.52-11.6-2.6-19.93l22.44-95.92H1943l-8,33.93-15.11,65.43c-9.43,40.93,17.18,74.42,59.15,74.42h44.21c33.56,0,67.22-26.77,74.78-59.53L2124.3,80.81h-52.22Z",
    transform: "translate(0 0)",
    style: {
      fill: "#1a171b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2869.59,342.28H2810v80.79h61.51v-14.3h-44.92V387.82h39.51V373.57h-39.51v-17h43ZM2749.3,393.12h18.85c-3.49,16.33-15.93,17.79-19.63,17.79-11.53,0-23.62-5.75-23.62-27.8,0-20.7,11.17-29,23.26-29s17.72,10.15,17.72,13.29h16.93c-.9-11.13-10.7-27.21-35.55-27.21H2747c-27.22,0-39.39,20.8-39.39,42.75,0,28.36,17.7,42.29,37.25,42.29,14.78,0,21-7.3,25.29-12.25l1.7,10.12h11.27V379.53H2749.3Zm-65.1-50.84h-17.26v53.21c0,9.79-4.76,15.42-16.37,15.42-7.92,0-14.47-5-14.47-16.22V342.28h-17.24v53.57c.21,8.09,1.92,14.6,6.3,19.56,7.23,8,18.3,9.79,25.75,9.79,20.43,0,33.29-9.13,33.29-30.38Zm-90.21,0H2534.4v80.79h61.53v-14.3H2551V387.82h39.51V373.57H2551v-17h43Zm-82.18,66.49h-42.7l42.46-53.2V342.28h-62v14.29h40.74l-41.86,52.2v14.3h63.33Zm-134.16-30.95V356.24h21.14c9.94,0,11.86,6.29,11.86,10.58,0,8-4.29,11-13.11,11Zm-16.57,45.25h16.57V391.45h17.51c12.55,0,13.22,4.28,13.22,15.29,0,8.32.68,12.5,1.81,16.33h18.73V420.9c-3.62-1.33-3.62-4.25-3.62-16.08,0-15.08-3.62-17.54-10.24-20.46,8-2.71,12.49-10.34,12.49-19.25,0-6.95-3.92-22.83-25.48-22.83h-41Zm-44.39-36.24v36.24h16.92V342.28h-16.92v30.61h-31.64V342.28h-16.92v80.79h16.92V386.83Zm-108-26.3h.22l10.06,32h-20.66Zm-14.89,45.87h29.91l5.2,16.67h18.4l-28.58-80.79h-19.52l-28.89,80.79h17.81Zm-74.32-17.32h35.67v-14.3h-35.67V356.57h40.75V342.28h-57.68v80.79h16.93Zm-82.08-46.8h-59.58v80.79h61.5v-14.3h-44.93V387.82h39.51V373.57h-39.51v-17h43Zm-104.79,14.29h24.51V342.28h-65.92v14.29h24.48v66.5h16.93Zm-77.5,42h-.22l-32.19-56.25H1804.9v80.79h15.8V365.45h.23L1854,423.07h16.93V342.28h-15.8Zm-76-56.25h-59.62v80.79h61.53v-14.3h-44.94V387.82h39.53V373.57h-39.53v-17h43Zm-120.33,50.84h18.88c-3.51,16.33-15.93,17.79-19.66,17.79-11.5,0-23.6-5.75-23.6-27.8,0-20.7,11.17-29,23.28-29,12,0,17.73,10.15,17.73,13.29h16.91c-.9-11.13-10.73-27.21-35.54-27.21h-.24c-27.23,0-39.39,20.8-39.39,42.75,0,28.36,17.71,42.29,37.22,42.29,14.8,0,21-7.3,25.31-12.25l1.69,10.12h11.29V379.53h-33.88Zm-65-50.84h-16.91v80.79h16.91Zm-78.09,0h-16.92v80.79H1556V408.44h-40.3Zm-78.26,0h-16.92v80.79h57.24V408.44h-40.32Zm-43.1,0h-59.6v80.79h61.53v-14.3h-44.94V387.82h39.53V373.57h-39.53v-17h43Zm-104.79,14.29h24.5V342.28h-65.92v14.29h24.5v66.5h16.92Zm-76.5,42h-.24l-32.18-56.25h-17.84v80.79h15.81V365.45h.22l33.09,57.62h16.92V342.28h-15.78Zm-76.46-56.25h-16.9v80.79h16.9Z",
    transform: "translate(0 0)",
    style: {
      fill: "#e2001a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2976.38,0V98.89L3075.26,0Zm177.47,0L2976.38,177.47V290.23L3266.61,0Zm247.72,326.3-98.89,98.9h98.89Zm0-191.35L3111.33,425.2h112.76l177.48-177.5Z",
    transform: "translate(0 0)",
    style: {
      fill: "#e2001a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3401.57 0 3345.19 0 2976.38 368.82 3032.74 368.83 3032.74 425.2 3401.57 56.37 3401.57 0",
    style: {
      fill: "#1a171b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchwarzmueller);
export default __webpack_public_path__ + "static/media/schwarzmueller.03e4e9963d2cd21c70ab7ed14de0ae9d.svg";
export { ForwardRef as ReactComponent };